module.exports = __webpack_public_path__ + "img/notifi-success.95027f4f.svg";